import { createListReducer } from 'app/redux/reducers/_reducer-factory/createListReducer';

const TEMPLATE_NAME = 'ADMINISTRATION_ROUTE';

export default createListReducer(TEMPLATE_NAME);
